import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetEpisodeStyle0 = gravityIconIndividualCss;

const GravityIconAssetEpisode = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '6a044b2d27e5925803f709a2aee287a8438f86fd', color: this.color, size: this.size }, h("svg", { key: '599b3e69b57004cd6df531502c7580b6d06adde8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'b57ee5a0cd3621da98d78b7a277d6e40bd3a4f36', d: "M9 13.2V8.51a.3.3 0 0 1 .45-.26l4.41 2.47a.3.3 0 0 1 0 .53l-4.43 2.21A.29.29 0 0 1 9 13.2Z", fill: "currentColor" }), h("path", { key: '4aa59f11ac7d154c2807628c2437bbc61ea02d30', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-17Zm16 1.5v11h-15v-11h15Z", fill: "currentColor" }))));
    }
};
GravityIconAssetEpisode.style = GravityIconAssetEpisodeStyle0;

export { GravityIconAssetEpisode as gravity_icon_asset_episode };

//# sourceMappingURL=gravity-icon-asset-episode.entry.js.map